"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TabSelector;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _styles = require("@sart/styles");
var _utilities = require("@sart/utilities");
var _Text = _interopRequireDefault(require("./Text"));
function TabSelector(props) {
  var value = props.value,
    options = props.options,
    onTabPress = props.onTabPress,
    textStyle = props.textStyle;
  var containerStles = [styles.container, _styles.theme.tabSelector.container];
  var separatorSyles = [styles.separator, _styles.theme.tabSelector.separator];
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: containerStles
  }, options.map(function (option, index, arr) {
    var isActive = value === option.value;
    var isDisabled = option.disabled;
    var isFirst = index === 0;
    var isLast = index === arr.length - 1;
    var tabStyles = [styles.tab, isFirst && styles.firstTab, isLast && styles.lastTab, isActive && [styles.activeTab, _styles.theme.tabSelector.activeTab], isDisabled && styles.disabledTab];
    var textStyles = [styles.text, isActive && styles.activeText, isDisabled && styles.disabledText, textStyle];
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: option.value
    }, /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, (0, _extends2["default"])({
      style: tabStyles,
      onPress: function onPress() {
        return onTabPress(option);
      },
      disabled: isDisabled
    }, (0, _utilities.testID)(option.label)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      style: textStyles
    }, option.label)), !isLast && /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
      style: separatorSyles
    }));
  }));
}
var radius = 3;
var border = 2;
var styles = _reactNative.StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: _styles.backgroundColors.feature,
    borderWidth: border,
    borderColor: _styles.backgroundColors.feature,
    borderRadius: radius + border
  },
  tab: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: _styles.backgroundColors.clear
  },
  firstTab: {
    borderTopLeftRadius: radius,
    borderBottomLeftRadius: radius
  },
  lastTab: {
    borderTopRightRadius: radius,
    borderBottomRightRadius: radius
  },
  activeTab: {
    backgroundColor: _styles.backgroundColors.feature
  },
  disabledTab: {},
  text: {
    lineHeight: 24,
    padding: 6,
    color: _styles.colors.feature
  },
  activeText: {
    color: _styles.colors.clear
  },
  disabledText: {
    color: _styles.colors.common
  },
  separator: {
    width: 1,
    backgroundColor: _styles.backgroundColors.feature
  }
});